import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ErrorBoundary, SentryErrorBoundaryHandle } from '@agilize/components-core';
import { setRoutes } from '@utils/routesHelper';
import LoggedLayout from '@components/layout/LoggedLayout';
import { routes } from './routes';

export const history = createBrowserHistory();

const NotFoundPage = lazy(() => import('@pages/404/NotFoundPage'));
const Dashboard = lazy(() => import('@pages/Dashboard/Dashboard'));
const Funcionarios = lazy(() => import('@pages/Funcionarios/Funcionarios'));
const Processos = lazy(() => import('@pages/Processos/Board/ProcessoBoard'));
const NovoProcesso = lazy(() => import('@pages/Processos/Novo/NovoProcesso'));
const Onboarding = lazy(() => import('@pages/Onboarding/Onboarding'));
const Admissao = lazy(() => import('@pages/Admissao/Admissao'));
const Afastamento = lazy(() => import('@pages/Afastamento/Afastamento'));
const Ferias = lazy(() => import('@pages/Ferias/Ferias'));
const Demissao = lazy(() => import('@pages/Demissao/Demissao'));
const FolhasPagamento = lazy(() => import('@pages/FolhasPagamento/FolhasPagamento'));
const FechamentoFolha = lazy(() => import('@pages/FolhasPagamento/Steps/Steps'));
const AlterarDados = lazy(() => import('@pages/AlterarDados/AlterarDados'));
const Dependentes = lazy(() => import('@pages/AlterarDados/Dependentes/Dependentes'));

const Routing = () => {
  useEffect(() => {
    setRoutes(routes);
  }, []);

  return (
    <ErrorBoundary onError={SentryErrorBoundaryHandle} callbackComponent={null}>
      <BrowserRouter>
        <LoggedLayout>
          <Suspense fallback={<></>}>
            <Switch>
              <Route path="/funcionarios" component={Funcionarios} />
              <Route path="/onboarding" component={Onboarding} />
              <Route path="/processos" exact component={Processos} />
              <Route path="/processos/card/:cardId" component={Processos} />
              <Route path="/processos/iniciar" exact component={NovoProcesso} />
              <Route path="/processos/onboarding" exact component={Onboarding} />
              <Route path="/processos/afastamentos/iniciar" exact component={Afastamento} />
              <Route path="/processos/alteracao-dados/iniciar" exact component={AlterarDados} />
              <Route path="/processos/ferias/iniciar" exact component={Ferias} />
              <Route path="/processos/demissoes/iniciar" exact component={Demissao} />
              <Route path="/processos/dependentes/iniciar" exact component={Dependentes} />
              <Route path="/processos/admissoes" component={Admissao} />
              <Route path="/folhas-pagamento/:id?" component={FolhasPagamento} />
              <Route path="/fechar-folha/:id" component={FechamentoFolha} />
              <Route path="/" exact component={Dashboard} />
              <Route path="*" component={NotFoundPage} />
            </Switch>
          </Suspense>
        </LoggedLayout>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default Routing;
